import React from 'react';
import { useTranslation } from 'react-i18next';
import { ValidationError } from '../ValidationError/ValidationError';
import './TextInput.scss';
import { FieldError } from 'react-hook-form';

type Props = {
  placeholder: string;
  value: string;
  onChange: (data: string) => void;
  onAfterChange: null | ((data: string) => void);
  errorType?: FieldError | undefined;
  errorMessageKey?: string;
  readOnly?: boolean;
  number?: boolean;
  validate?: boolean;
};

export const TextInput = (props: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {props.validate !== false && (
        <>
          <ValidationError
            errorType={props.errorType}
            errorMessageKey={props.errorMessageKey || ''}
          />
        </>
      )}
      <input
        className={(props.errorType && 'is-danger ') + ' input input-text'}
        type={props.number ? 'number' : 'text'}
        value={props.value}
        placeholder={t(props.placeholder)}
        onBlur={(e) => {
          if (props.onAfterChange !== null) {
            props.onAfterChange(e.target.value);
          }
        }}
        onChange={(e) => {
          props.onChange(e.target.value);
        }}
        readOnly={props.readOnly}
      />
    </>
  );
};
